export default __webpack_public_path__ + "static/media/CVicon.813deced.png";